import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { Button, Card, Input } from '@copilot/ui';
import { Field } from '../components/common/Field';
import * as authApi from '../services/authApi';
import { getUserFriendlyError } from '../utils/errors';

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setIsSubmitting(true);

    try {
      await authApi.resetPassword({ token, newPassword });
      setSuccess(true);
      setTimeout(() => navigate('/login', { replace: true }), 1500);
    } catch (err) {
      setError(getUserFriendlyError(err, 'Unable to connect. Please try again.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-brand">
          <div className="auth-brand-title">KrishvaQ</div>
          <div className="auth-brand-subtitle">AI Meeting Assistant</div>
        </div>

        <Card interactive>
          <div className="auth-heading">Reset Password</div>

          {!token ? (
            <div className="form-alert">
              This reset link is missing a token. Request a new link from the
              Forgot Password page.
            </div>
          ) : success ? (
            <p>Password updated. Redirecting to login...</p>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              <Field label="New Password" htmlFor="reset-password">
                <Input revealable type="password"
                  id="reset-password"
                  autoComplete="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
              </Field>

              <Field label="Confirm New Password" htmlFor="reset-confirm">
                <Input revealable type="password"
                  id="reset-confirm"
                  autoComplete="new-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </Field>

              {error && <div className="form-alert">{error}</div>}

              <Button type="submit" block disabled={isSubmitting}>
                {isSubmitting ? 'Saving...' : 'Reset Password'}
              </Button>
            </form>
          )}
        </Card>

        <div className="auth-footer-link">
          <Link to="/login">Back to Login</Link>
        </div>
      </div>
    </div>
  );
}

export default ResetPasswordPage;
